module.exports = __webpack_public_path__ + "img/bg-psim.dc87062f.jpg";